$mol_image2 $mol_view
	links /
	aspect 1
	sub /
		<= Content $mol_view
			style *
				paddingTop <= height \100%
				backgroundImage <= background \
